/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {browseMarketplace} from '../api'

export const useMutationBrowseMarketplace = createReactQueryMutationHook('browseMarketplace', browseMarketplace)
